import { Auth, API } from 'aws-amplify';
import { apiGateway } from './config';

const ApiHeaders = async () => ({
  ...apiGateway.apiInit.headers,
  Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
});

const createApiInit = async options => ({
  ...apiGateway.apiInit,
  ...options,
  headers: await ApiHeaders()
});

const ApiGet = async (path, queryStringParameters = undefined) => {
  const init = await createApiInit(
    queryStringParameters ? { queryStringParameters } : undefined
  );

  return API.get(apiGateway.apiName, apiGateway.apiPath + path, init);
};

const ApiGetNoWait = async path => {
  const init = await createApiInit();
  return API.get(apiGateway.apiName, apiGateway.apiPath + path, init);
};

const ApiGetArray = async getArray => {
  const init = await createApiInit();
  return Promise.all(
    getArray.map(path => API.get(apiGateway.apiName, apiGateway.apiPath + path, init))
  );
};

const ApiCall = async item => {
  const path = apiGateway.apiPath + item.resource;

  if (item.method === 'POST') {
    const init = await createApiInit({ body: item.body });
    return API.post(apiGateway.apiName, path, init);
  }

  const init = await createApiInit();
  return API.get(apiGateway.apiName, path, init);
};

const ApiCallArray = async callArray => {
  const calls = Array.isArray(callArray) ? callArray : [callArray];
  return Promise.all(calls.map(ApiCall));
};

const ApiPost = async (path, body) => {
  const init = await createApiInit({ body });
  return API.post(apiGateway.apiName, apiGateway.apiPath + path, init);
};

export { ApiGet, ApiGetNoWait, ApiGetArray, ApiCallArray, ApiHeaders, ApiPost };
